@if (type == 'year') {
  <mat-form-field [appearance]="appearance">
    <mat-label>{{ label }}</mat-label>
    <input matInput [matDatepicker]="db" [formControl]="date" autocomplete="off" />
    @if (matHint) {
      <mat-hint>YYYY</mat-hint>
    }
    <mat-datepicker-toggle matIconSuffix [for]="db"></mat-datepicker-toggle>
    <mat-datepicker #db startView="multi-year" (yearSelected)="chosenDateHandlerYear($event, db)"
      panelClass="example-month-picker">
    </mat-datepicker>
  </mat-form-field>
}

@if (type == 'month') {
  <mat-form-field [appearance]="appearance">
    <mat-label>{{ label }}</mat-label>
    <input matInput [matDatepicker]="db" [formControl]="date" autocomplete="off" />
    @if (matHint) {
      <mat-hint>MM/YYYY</mat-hint>
    }
    <mat-datepicker-toggle matIconSuffix [for]="db"></mat-datepicker-toggle>
    <mat-datepicker #db startView="multi-year" (monthSelected)="chosenDateHandlerMonth($event, db)"
      panelClass="example-month-picker">
    </mat-datepicker>
  </mat-form-field>
}


@if (type == '' || type =='date') {
  <mat-form-field [appearance]="appearance">
    <mat-label>{{ label }}</mat-label>
    <input matInput [matDatepicker]="db" [formControl]="fullDate" autocomplete="off"
      (dateChange)="chosenDateHandlerDate()" />
    @if (matHint) {
      <mat-hint>MM/DD/YYYY</mat-hint>
    }
    <mat-datepicker-toggle matIconSuffix [for]="db"></mat-datepicker-toggle>
    <mat-datepicker #db [touchUi]="movil ? true : false"></mat-datepicker>
  </mat-form-field>
}